var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodesandbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 29.3333V14.6667C38.4993 14.0237 38.3296 13.3922 38.0078 12.8355C37.686 12.2788 37.2235 11.8165 36.6667 11.495L23.8333 4.16168C23.2759 3.83986 22.6436 3.67044 22 3.67044C21.3564 3.67044 20.7241 3.83986 20.1667 4.16168L7.33333 11.495C6.77648 11.8165 6.31396 12.2788 5.99218 12.8355C5.6704 13.3922 5.50066 14.0237 5.5 14.6667V29.3333C5.50066 29.9763 5.6704 30.6079 5.99218 31.1645C6.31396 31.7212 6.77648 32.1835 7.33333 32.505L20.1667 39.8383C20.7241 40.1602 21.3564 40.3296 22 40.3296C22.6436 40.3296 23.2759 40.1602 23.8333 39.8383L36.6667 32.505C37.2235 32.1835 37.686 31.7212 38.0078 31.1645C38.3296 30.6079 38.4993 29.9763 38.5 29.3333Z",
    stroke: "#3B7DDD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.71832L22 12.485L30.25 7.71832",
    stroke: "#3B7DDD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 36.2817V26.7667L5.5 22",
    stroke: "#3B7DDD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 22L30.25 26.7667V36.2817",
    stroke: "#3B7DDD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99512 12.76L22.0001 22.0183L38.0051 12.76",
    stroke: "#3B7DDD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 40.48V22",
    stroke: "#3B7DDD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodesandbox);
export default __webpack_public_path__ + "static/media/codesandbox.ccddf6ebd76766c5f874b60158b5397d.svg";
export { ForwardRef as ReactComponent };